import './button.scss'
import * as React from 'react';
import { useNavigate } from 'react-router-dom';

const CommonButton = ({ text, fontFamily, routePath, onClickFunc, disabled }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (routePath)
      navigate(routePath);
    else onClickFunc();
  }

  return (
    <button onClick={handleClick} tabIndex="true" disabled={disabled}
      style={{ fontFamily: fontFamily, '--text-chars-count': text.length }}
      className='common-button background-transition-only'>
      {text}
    </button>
  );
};

export default CommonButton;